
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators, FormGroup, ValidatorFn } from '@angular/forms';
import { timeSlotDialogModel } from "../models";

/*
export function forbiddenNameValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = nameRe.test(control.value);
    return forbidden ? {'forbiddenName': {value: control.value}} : null;
  };
}
*/

@Component({
  selector: 'app-slot-dialog',
  templateUrl: './slot-dialog.component.html',
  styleUrls: ['./slot-dialog.component.css']
})
export class SlotDialogComponent implements OnInit {
    form: FormGroup;
    dialogInput: timeSlotDialogModel;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<SlotDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: timeSlotDialogModel) {
        
        this.dialogInput = data;
        this.form = fb.group({
            chosenId: [ this.dialogInput.chosenId.toString(), [ Validators.required ] ], 
            numBookings: [this.dialogInput.numBookings, [ Validators.required, Validators.min(1) ]]
        });
    }

    ngOnInit() {
    }

    get chosenId() { return this.form.get('chosenId'); }

    get numBookings() { return this.form.get('numBookings'); }    

    dialogTitle(): string {
      if (this.dialogInput.chosenId == 0)
        return `New Time Slot - ${this.dialogInput.startTime}`;
      else
        return `Edit Time Slot - ${this.dialogInput.startTime}`;
    }

    save() {
        this.dialogRef.close(this.form.value);
    }

    close() {
        this.dialogRef.close();
    }
}
